const SwitchBarButton = () => (
  <div className="w-1/6">
    <button className="bg-white rounded-full w-full text-center h-6 text-sm text-dark-gray">SEND MESSAGE</button>
  </div>
);

export default SwitchBarButton;
